import { HandlingUnit } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'handling-unit';

export class HandlingUnitController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findAll(): Promise<HandlingUnit[]> {
    const response = await this.http.get<HandlingUnit[]>('');
    return response.data.map((val) => new HandlingUnit(val));
  }
}
